import { useParams } from 'react-router-dom';
import { UUID } from '@/types';

export const useSeriesId = () => {
  const { seriesId } = useParams<{ seriesId: UUID }>();

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return seriesId;
};
